module.exports = __webpack_public_path__ + "static/media/gramado-rs.5154064a.jpg";